export default "__VITE_ASSET__CNK_8MHm__"